import {ChargeOrderPaymentRequestErrorCode, PaymentResult} from '../../../types/paymentRequestApp.types';

export const isSuccessfulPaymentStatus = (clientStatus?: string): boolean =>
  clientStatus === PaymentResult.Approved ||
  /* istanbul ignore next */
  clientStatus === PaymentResult.Pending;

export const isNoLongerChargeableErrorCode = (code?: string): boolean =>
  code === ChargeOrderPaymentRequestErrorCode.cannotChargePaid ||
  code === ChargeOrderPaymentRequestErrorCode.cannotChargeExpired ||
  code === ChargeOrderPaymentRequestErrorCode.cannotChargeVoided;
